import { TQuestionMap } from '../types/internal';
import { TFormStoreData } from '../../../types/form';

export const getQuestionsMap = (formData: TFormStoreData) =>
  formData.questions.reduce(
    (map, question) => ({
      ...map,
      [question.code]: question,
    }),
    {} as TQuestionMap,
  );
